/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.builder
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.builder = require('./content_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.builder.ContentServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.CreateContentRequest,
 *   !proto.io.codedrills.proto.builder.CreateContentResponse>}
 */
const methodInfo_ContentService_CreateContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.CreateContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.CreateContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.CreateContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.CreateContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.CreateContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.CreateContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.createContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/CreateContent',
      request,
      metadata || {},
      methodInfo_ContentService_CreateContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.CreateContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.CreateContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.createContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/CreateContent',
      request,
      metadata || {},
      methodInfo_ContentService_CreateContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.GetContentRequest,
 *   !proto.io.codedrills.proto.builder.GetContentResponse>}
 */
const methodInfo_ContentService_GetContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.GetContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.GetContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.GetContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.GetContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.GetContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.GetContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.getContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetContent',
      request,
      metadata || {},
      methodInfo_ContentService_GetContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.GetContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.GetContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.getContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetContent',
      request,
      metadata || {},
      methodInfo_ContentService_GetContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.UpdateContentRequest,
 *   !proto.io.codedrills.proto.builder.UpdateContentResponse>}
 */
const methodInfo_ContentService_UpdateContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.UpdateContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.UpdateContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.UpdateContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.UpdateContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.updateContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateContent',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.UpdateContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.updateContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateContent',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.CreateAttachmentRequest,
 *   !proto.io.codedrills.proto.builder.CreateAttachmentResponse>}
 */
const methodInfo_ContentService_CreateAttachment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.CreateAttachmentResponse,
  /** @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.CreateAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.CreateAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.CreateAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.createAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/CreateAttachment',
      request,
      metadata || {},
      methodInfo_ContentService_CreateAttachment,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.CreateAttachmentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.createAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/CreateAttachment',
      request,
      metadata || {},
      methodInfo_ContentService_CreateAttachment);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.ListContentRequest,
 *   !proto.io.codedrills.proto.builder.ListContentResponse>}
 */
const methodInfo_ContentService_ListContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.ListContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.ListContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.ListContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.ListContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.ListContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.ListContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.listContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/ListContent',
      request,
      metadata || {},
      methodInfo_ContentService_ListContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.ListContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.ListContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.listContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/ListContent',
      request,
      metadata || {},
      methodInfo_ContentService_ListContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.DeleteContentRequest,
 *   !proto.io.codedrills.proto.builder.DeleteContentResponse>}
 */
const methodInfo_ContentService_DeleteContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.DeleteContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.DeleteContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.DeleteContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.DeleteContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.deleteContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/DeleteContent',
      request,
      metadata || {},
      methodInfo_ContentService_DeleteContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.DeleteContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.deleteContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/DeleteContent',
      request,
      metadata || {},
      methodInfo_ContentService_DeleteContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.PublishContentRequest,
 *   !proto.io.codedrills.proto.builder.PublishContentResponse>}
 */
const methodInfo_ContentService_PublishContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.PublishContentResponse,
  /** @param {!proto.io.codedrills.proto.builder.PublishContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.PublishContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.PublishContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.PublishContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.PublishContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.publishContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/PublishContent',
      request,
      metadata || {},
      methodInfo_ContentService_PublishContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.PublishContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.PublishContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.publishContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/PublishContent',
      request,
      metadata || {},
      methodInfo_ContentService_PublishContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.UpdateTestDurationRequest,
 *   !proto.io.codedrills.proto.builder.UpdateTestDurationResponse>}
 */
const methodInfo_ContentService_UpdateTestDuration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.UpdateTestDurationResponse,
  /** @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.UpdateTestDurationResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.UpdateTestDurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.UpdateTestDurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.updateTestDuration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateTestDuration',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateTestDuration,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.UpdateTestDurationResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.updateTestDuration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateTestDuration',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateTestDuration);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.ExportProblemRequest,
 *   !proto.io.codedrills.proto.builder.ExportProblemResponse>}
 */
const methodInfo_ContentService_ExportProblem = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.ExportProblemResponse,
  /** @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.ExportProblemResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.ExportProblemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.ExportProblemResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.exportProblem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/ExportProblem',
      request,
      metadata || {},
      methodInfo_ContentService_ExportProblem,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.ExportProblemResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.exportProblem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/ExportProblem',
      request,
      metadata || {},
      methodInfo_ContentService_ExportProblem);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.GetTestCaseRequest,
 *   !proto.io.codedrills.proto.builder.GetTestCaseResponse>}
 */
const methodInfo_ContentService_GetTestCase = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.GetTestCaseResponse,
  /** @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.GetTestCaseResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.GetTestCaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.GetTestCaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.getTestCase =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetTestCase',
      request,
      metadata || {},
      methodInfo_ContentService_GetTestCase,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.GetTestCaseResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.getTestCase =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetTestCase',
      request,
      metadata || {},
      methodInfo_ContentService_GetTestCase);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.GetMetaDataRequest,
 *   !proto.io.codedrills.proto.builder.GetMetaDataResponse>}
 */
const methodInfo_ContentService_GetMetaData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.GetMetaDataResponse,
  /** @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.GetMetaDataResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.GetMetaDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.GetMetaDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.getMetaData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetMetaData',
      request,
      metadata || {},
      methodInfo_ContentService_GetMetaData,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.GetMetaDataResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.getMetaData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/GetMetaData',
      request,
      metadata || {},
      methodInfo_ContentService_GetMetaData);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.UpdateMetaDataRequest,
 *   !proto.io.codedrills.proto.builder.UpdateMetaDataResponse>}
 */
const methodInfo_ContentService_UpdateMetaData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.UpdateMetaDataResponse,
  /** @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.UpdateMetaDataResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.UpdateMetaDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.UpdateMetaDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.updateMetaData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateMetaData',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateMetaData,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.UpdateMetaDataResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.updateMetaData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UpdateMetaData',
      request,
      metadata || {},
      methodInfo_ContentService_UpdateMetaData);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.builder.UploadMcqCsvRequest,
 *   !proto.io.codedrills.proto.builder.UploadMcqCsvResponse>}
 */
const methodInfo_ContentService_UploadMcqCsv = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.builder.UploadMcqCsvResponse,
  /** @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.builder.UploadMcqCsvResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.builder.UploadMcqCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.builder.UploadMcqCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.builder.ContentServiceClient.prototype.uploadMcqCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UploadMcqCsv',
      request,
      metadata || {},
      methodInfo_ContentService_UploadMcqCsv,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.builder.UploadMcqCsvResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.builder.ContentServicePromiseClient.prototype.uploadMcqCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.builder.ContentService/UploadMcqCsv',
      request,
      metadata || {},
      methodInfo_ContentService_UploadMcqCsv);
};


module.exports = proto.io.codedrills.proto.builder;

